function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M193 256l34-70 4-15V77h68v94l4 15 34 70zm0 0h144zM342 77h5c13 0 22-10 22-22 0-11-10-21-22-21H182c-12 0-22 10-22 21 0 12 10 22 22 22h7v91h-1l-46 97-78 150c-22 42-1 76 46 76h303c47 0 68-35 48-77 0 0-50-102-69-142l-50-104z"
})));